import { mask } from 'remask';

export function isValidDate(day: number, month: number, year: number): boolean {
  if (year < 1 || year > 9999) return false;
  if (month < 1 || month > 12) return false;

  if (month === 2) {
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      // Ano bissexto
      return day > 0 && day <= 29;
    } else {
      return day > 0 && day <= 28;
    }
  }

  const longMonths = [1, 3, 5, 7, 8, 10, 12];
  if (longMonths.includes(month)) {
    return day > 0 && day <= 31;
  } else {
    return day > 0 && day <= 30;
  }
}

function convertISOToBrazilianDate(isoDate: string) {
  const [year, month, day] = isoDate.split('T')[0].split('-');

  const formatedDate = `${day}/${month}/${year}`;

  return formatedDate;
}

export function maskDate(value: string | undefined): string {
  if (!value) return '';

  // Converta a data ISO para o formato brasileiro, se for o caso
  if (value.includes('T')) {
    value = convertISOToBrazilianDate(value);
  }

  let result = mask(value, ['99/99/9999']);

  const [day, month, year] = result.split('/').map((e) => parseInt(e, 10));

  if (!isValidDate(day, month, year)) {
    if (day > 31) result = result.replace(/^\d{2}/, '31');
    if (month > 12) result = result.replace(/\/\d{2}\//, '/12/');
  }

  return result;
}
